// extracted by mini-css-extract-plugin
export default {"question":"styles_question__DOVJi","normal":"styles_normal__VUX8M","normalList":"styles_normalList__UpDIT"};